<template>
  <b-table v-bind="tableAttributes" :items="items" :fields="fields">

    <template #cell(id)="data">
      <span class="text-wrap">{{ data.item.id }}</span>
    </template>

    <template #cell(subject)="data">
      <span>{{ data.item.subject }}</span>
    </template>

    <template #cell(status_id)="data">
      <select v-if="$store.getters['User/isAdmin']"
              @change="setDataForChangeChatStatus(data)"
              v-model="data.item.status_id" class="form-control">
        <option class="text-dark" v-for="(chat_status_item,index) in ChatStatus"
                :value="index">
          {{ chat_status_item }}
        </option>
      </select>

      <span v-else>{{ data.item.status }}</span>
    </template>

    <template #cell(user_chat)="data">
      <div class="" v-for="user in data.item.user_chat">
        <m-a class="d-block" target="_blank" :href="{ name: 'UserChats', query: { user: user.id } }">
          {{ user.name }} {{ user.last_name }}
        </m-a>
      </div>
    </template>

    <template #cell(chat_type)="data">
      <span>{{ data.item.type.type_status }}</span>
    </template>

    <template #cell(created_at)="data">
      <div class="" dir="ltr">
        {{ dateConverter(data.item.created_at, '/', true) }}
      </div>
    </template>
    <template #cell(updated_at)="data">
      <div class="" dir="ltr">
        {{ dateConverter(data.item.updated_at, '/', true) }}
      </div>
    </template>

    <template #cell(action)="data">
      <m-a target="_blank" :href="{name:'SingleChat',params:{slug:data.item.slug}}">
        <span
            class="h4 "
            v-b-tooltip.hover
            title="مشاهده">
        <b-icon icon="messenger" class="m-3"/>
        </span>
      </m-a>
    </template>

  </b-table>
</template>
<script>
import {mapActions} from 'vuex';
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {ChatStatus} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Chat';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue';
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "tableItemOfOrders",
  components: {FormGroup, FormErrorsManager,},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "id", label: "شناسه چت"},
        {key: "subject", label: "موضوع"},
        {key: "status_id", label: "وضعیت"},
        {key: "chat_type", label: "نوع"},
        {key: "user_chat", label: "کاربران چت"},
        {key: "created_at", label: "شروع چت"},
        {key: "updated_at", label: "آخرین به روزرسانی"},
        {key: "action", label: ""},
      ],
      ChatStatus,
      order_id: '',
    };
  },
  validations: {
    commentForm: {
      body: {required},
      rate: {required}
    },
  },
  computed: {
    getOrderStatus() {
      return this.order_status;
    }
  },
  methods: {
    ...mapActions({
      changeOrderStatus: 'ShoppingCart/changeOrderStatus',
    }),
    setDataForChangeChatStatus(data) {
      const chat_id = data.item.id;
      const status = data.item.status_id;
      const form = {id: chat_id, status: status}
      this.$store.dispatch('Chat/changeChatStatus', form)
          .then((res) => {
            toast('.عملیات با موفقیت انجام شد', 'تغییر وضعیت چت با موفقیت انجام شد.', 'success')
          })
          .catch((error) => {
            console.log(error);
          });
    },
    formatNumber,
    dateConverter,
    addEnterBetweenDateAndTime(date) {
      date = this.dateConverter(date, '/', true);
      return date.replace(' ', '<br>')
    },
    setOrderId(id) {
      this.order_id = id
      this.commentForm.commentable_id = id
    },
    createComment() {
      if (this.commentForm.rate === 0) {
        this.commentForm.rate = 1
      }
      this.$store.dispatch("Comment/createComment", this.commentForm).then(res => {
        toast('', 'کامنت شما با موفقیت ثبت شد و در انتظار برای تایید قرار گرفت')
      })
    },
    resetCommentForm() {
      this.commentForm = {
        body: '',
        rate: 1,
        commentable_type: 'order',
        commentable_id: ''
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.createComment()
        this.$nextTick(() => {
          this.$bvModal.hide('comment-' + this.order_id)
          this.resetCommentForm()
        })
      }
    },
    updateOrderGeneralInfo(data) {
      const form = {
        order_id: data.id,
        shipment_code: data.shipment_code,
      }
      this.$store.dispatch('ShoppingCart/updateOrderGeneralInfo', form)
    }
  },

};
</script>

<style scoped>

.box {
  align-self: flex-end;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  background-color: transparent;
  color: orange;
  margin: 0 auto 0 auto;
  transform-origin: bottom;

}

.bounce-7 {
  animation-name: bounce-7;
  animation-timing-function: cubic-bezier(0.280, 0.840, 0.420, 1);
}

@keyframes bounce-7 {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(1.1, .9) translateY(0);
  }
  30% {
    transform: scale(.9, 1.1) translateY(-17px);
  }
  50% {
    transform: scale(1.05, .95) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(-7px);
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}

.rate-s {
  height: 40px !important;
  width: max-content !important;
}

</style>